import $http from './http'
import config from './config'
export default {
    name: 'chargepolicy',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getChargeList(data){
        return $http.post(this.getUrl('/ChargeInfo/List'),data);
    },
    getChargeDetails(id){
        return $http.get(this.getUrl(`/ChargeInfo/Details/${id}`));
    },
    saveChargeInfo(data){
        return $http.post(this.getUrl('/ChargeInfo/Save'),data);
    },
    getProductInfo(data,options){
        return $http.post(this.getUrl('/PolicyInfo/ProductInfo'),data,options);
    }
}


// WEBPACK FOOTER //
// ./src/apis/chargepolicyapi.js